import { ThemeTypes } from '@talos/kyoko/src/styles/themes';
import type { DefaultTheme } from 'styled-components';
import styled from 'styled-components';
import type { PanelType } from '../../types/LayoutConfig';
import { LayoutWrapper } from '../Layout/styles';

export const PreviewLayoutWrapper = styled(LayoutWrapper)`
  overflow: hidden;
  pointer-events: none;
  border-radius: 6px;
  flex: 1 1 auto;

  .dockview-theme-dark.dockview-theme-dark {
    --dv-tabs-and-actions-container-height: 14px;
    --dv-tabs-and-actions-container-font-size: 0.5rem;
    --dv-group-view-background-color: transparent;
    --dv-tabs-container-background-color: var(--backgroundModal);
    --dv-tabs-and-actions-container-background-color: var(--backgroundModal);

    .dv-tabs-and-actions-container {
      border: none;
    }

    .dv-groupview {
      border-radius: 6px;
      border: 1px solid var(--colors-gray-040);
    }

    .dv-tabs-container.dv-horizontal {
      background: transparent;
      border: none;
      .dv-tab:last-child {
        border-radius: 0 6px 0 0;
        overflow: hidden;
      }
    }
    .dv-tabs-overflow-dropdown-default {
      svg {
        width: 6px;
        height: 6px;
      }
    }
  }
`;

export function previewTabBackground(theme: DefaultTheme) {
  return theme.type === ThemeTypes.dark ? theme.colors.gray['040'] : theme.colors.gray['020'];
}

export function panelPreviewBackground(theme: DefaultTheme, type: PanelType) {
  return theme.type === ThemeTypes.dark
    ? `linear-gradient(to bottom, ${theme.colors.gray['040']}, ${theme.backgroundModal})`
    : `linear-gradient(to bottom, ${theme.colors.gray['020']}, ${theme.colors.gray['040']})`;
}
